import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';
import { InvoiceList } from '../models/invoice-list.model';

@Injectable()
export class GetInvoicesUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(query: string): Observable<InvoiceList> {
    return this.repository.getInvoices(query);
  }
}

